import { ChangePasswordFormValues, ChangePasswordRequestDto } from '../types';

export const mapChangePasswordData = (
  values: ChangePasswordFormValues
): ChangePasswordRequestDto => ({
  current_password: values.oldPassword,
  new1_password: values.newPassword,
  new2_password: values.reEnterPassword,
});
